import axios from 'axios';
import CryptoJS from 'crypto-js';
import Paginate from 'vuejs-paginate';
import VueElementLoading from 'vue-element-loading';
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css';
import AdminSettingsService from './../../services/adminsettings.service';
import {Validator} from 'vee-validate';
import CargoAllocationService from '../../../cargoallocation/services/cargoallocation.service'
import MasterService from '../../../masterdata/services/masterdata.service'
import ClientService from '../../../clientmanagement/services/clientmanagement.service'
import FLMConfig from './FLMConfiguration'
import Clientmanagement from './clientManagement';
import Cargobooking from './cargobooking';
import Croncentraldb from './cronandcentraldb';
import redis from './redis'
export default {
  name: 'changedefaulthub',
  components: {
    VueElementLoading,
    Paginate,
    Multiselect,
    FLMConfig,
    Clientmanagement,
    Cargobooking,
    Croncentraldb,
    redis
  },
  props: [],
  data: function() {
    return {
      isLoading:false,
      adminsettingdata:[],
      HSNCode:"",
      StatesLimit:[],
      SelectedStates:'',
      exemptHSN:'',
      states:'',
      printstickeroptions:"",
      cft:'',
      hubaccess:[],
      hubaccessObjArray:[],
      currentHub:'',
      hubid:'',
      hubid1:'',
      isPalletScan:'',
      scanType:'',
      originhubids:null,
      destinationhubids:null,
      Clientlist:[],
      ClientBusinessAccountlist:[],
	  ClientOTPlist:[],
	  selectedOTPClients:[],
      selectedClients:[],
      selectedClientsForClientRefNo:[],
      selectedClientsForRefNo:[],
      selectedClientsForDisabledWt:[],
      tableList: [
        {
          tablename: 'cargouadshipment'
        },
        {
          tablename: 'cargotripawbcharges'
        },
        {
          tablename: 'cargotripawb'
        },
        {
          tablename: 'cargotripmps'
        },
        {
          tablename: 'cargotripshipmentsku'
        },
        {
          tablename: 'cargopod'
        },
        {
          tablename: 'cargotripmpsstatuslog'
        },
        {
          tablename: 'cargodeliveryextracharges'
        },
        {
          tablename: 'clientcontract'
        },
        {
          tablename: 'clientcontractrate'
        },
        {
          tablename: 'cargotripmaster'
        },
        {
          tablename: 'awbjourney'
        },
        {
          tablename: 'mpsjourney'
        },
        {
          tablename: 'awbhandover'
        },
        {
          tablename: 'mpshandover'
        },
        {
          tablename: 'clientcontractservices'
        },
        {
          tablename: 'clientcontractratebaserate'
        },
        {
          tablename: 'clientcontractrateinsurancerate'
        },
        {
          tablename: 'clientcontractratevehicledelivery'
        },
        {
          tablename: 'cargopickuprequests'
        },
      ],
      selectedTables:[],
      redisService: 0,
      MaxVolWt : null,
      MaxVolWtAWB : null,
      ftccashlimit:"",
      prcutofftime:"",
      FTCAMterr:"",
      RolesList:[],
      roleId:'',
      rolename:'',
      autocutoffweight:"",
      autofetchdatalimit:"",
      prCutoofSelected:0,
      prCutoofBackspace:0,
	  mpsPrintDisabledClients:"",
	  OTPBasedDelivery:"",
	  ClientReferenceNolist:"",
	  ReferenceNolist:"",
	  ClientsForDisabledWt:"",
    ClientsForDisableDWS:"",
	  clientlist:[],
      ShowClientDetails:false,
	  clinetnamelist:"",
	ShowAwbCopy:false,
	ShowMpsCopy:false,
	ShowAwbCopyDetails:false,
	printcopy:'',
	awblrcopy:'',
	mpssticker:'',
	mpsstickerprint:'',
	bookingfield:'',
	bookingfieldlist1:[
		{ key:'Reference Number', value:'referenceno',disable:0},
        { key:'Consignee Code', value:'ConsigneeCode',disable:0},
        { key:'Company Name (Consignee)', value:'consigneename',disable:0},
        { key:'Consignee POC', value:'ConsigneePOC',disable:0},
        { key:'Pickup Location', value:'PickupLocation',disable:0},
        { key:'Client Reference Number', value:'ClientReferenceNo',disable:0},
	],
	bookingfieldlist2:[
		{ key:'Reference Number', value:'referenceno',disable:0},
        { key:'Consignee Code', value:'ConsigneeCode',disable:0},
        { key:'Company Name (Consignee)', value:'consigneename',disable:0},
        { key:'Consignee POC', value:'ConsigneePOC',disable:0},
        { key:'Pickup Location', value:'PickupLocation',disable:0},
        { key:'Client Reference Number', value:'ClientReferenceNo',disable:0},
	],
	bookingfieldlist3:[
		{ key:'Reference Number', value:'referenceno',disable:0},
        { key:'Consignee Code', value:'ConsigneeCode',disable:0},
        { key:'Company Name (Consignee)', value:'consigneename',disable:0},
        { key:'Consignee POC', value:'ConsigneePOC',disable:0},
        { key:'Pickup Location', value:'PickupLocation',disable:0},
        { key:'Client Reference Number', value:'ClientReferenceNo',disable:0},
		{ key:'Invoice Number', value:'InvoiceNumber',disable:0},
		{ key:'EWB Number', value:'ebn',disable:0},
		{ key:'Consignee Address', value:'ConsigneeAddress',disable:0},
	],
	mpsfieldlist1:[
		{ key:'Reference Number', value:'referenceno',disable:0},
        { key:'Consignee Code', value:'ConsigneeCode',disable:0},
        { key:'Company Name (Consignee)', value:'consigneename',disable:0},
        { key:'Consignee POC', value:'ConsigneePOC',disable:0},
        { key:'Client Reference Number', value:'ClientReferenceNo',disable:0},
		{ key:'Invoice Number', value:'InvoiceNumber',disable:0},
		{ key:'EWB Number', value:'ebn',disable:0},
	],
	mpsfieldlist2:[
		{ key:'Reference Number', value:'referenceno',disable:0},
        { key:'Consignee Code', value:'ConsigneeCode',disable:0},
        { key:'Company Name (Consignee)', value:'consigneename',disable:0},
        { key:'Consignee POC', value:'ConsigneePOC',disable:0},
        { key:'Client Reference Number', value:'ClientReferenceNo',disable:0},
		{ key:'Invoice Number', value:'InvoiceNumber',disable:0},
		{ key:'EWB Number', value:'ebn',disable:0},
	],
	awblrcopydata:{},
	mpsstickerdata:{},
	selectedAwbCopy:[null,null,null],
	selectedMpsCopy:[null,null],
	bookingfield1:'',
	bookingfield2:'',
	bookingfield3:'',
	bookinglabel1:'',
	bookinglabel2:'',
	bookinglabel3:'',
	bookingmpslabel1:'',
	bookingmpslabel2:'',
	bookingmpsfield1:'',
	bookingmpsfield2:'',
	bookingmpsfieldlist1:'',
	bookingmpsfieldlist2:'',
    ConsigneeCodeOnMps:"",
	clientdata:{},
	RelianceSecondaryClient:"",
	ProofOfPickup:"",
  ShowGlobalPickup:false,
  globalpickuppincodedataArray:[],
  globalpickup:'',
  pincode:[],
  ShowClientDetailsforglobalpickup:false,
  GlobalPickupClientPincodeData:{},
  disablesave:false,
  isDwsScanEnable:'',
	  dwshub:'',
    ShowGlobalDelivery:false,
    globaldeliverypincode:[],
    enableverification: "",
    prwtthreshold:500,
    blockclient: false,
    blockpickup : 0,
    blockdelivery : 0,
    blockclientreason:"",
    blockclientcode : {},
    ShowGlobalDropoff:false,
    globaldropoffpincode:[],
    globaldropoff:'',
    globaldropoffpincodedataArray:[],
    globaldeliveryflag:'',
    showFlm:true
    }
  },
  computed: {
  },
  async mounted() {
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    this.isLoading = true
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.localuserid = userdetail.userid;
    this.useremail = userdetail.email;
    this.currentHub = userdetail.hubID[0];
    await Promise.all([this.getStatelist(),this.loadAllHubAccessList(),this.getCompanyShortName(),this.getRoleList()]);
    await this.getAdminSettings();
    this.isLoading = false
  },
  methods: {
    isIntegerOnly: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if (charCode < 48 || charCode > 57) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    async onchange(id){
      try {
        this.isLoading = true;
        let payload ={
          username: this.useremail,
          hubid:id.hubid
        }
        let scandata = await AdminSettingsService.getAdminSettings(payload);
        if(scandata.data.data.hubdata){
          this.isPalletScan = scandata.data.data.hubdata.ispalletscan
          this.scanType = scandata.data.data.hubdata.scantype
		  this.isDwsScanEnable = scandata.data.data.hubdata.isdwsscanenable
        }else{
          this.isPalletScan=""
          this.scanType=""
		  this.isDwsScanEnable=""
        }
        this.isLoading = false;
      } catch (error) {
        console.log(error);
        this.isLoading = false;
      }
    },
    async loadAllHubAccessList() {
      try {
        let InputPayload = {};
      this.isLoading = true;
      let response = await MasterService.GetHublist(InputPayload);
      if(response.data.code===200){
        this.hubaccess = response.data.data.data;
        for (var i = 0; i < this.hubaccess.length; i++) {
          this.hubaccessObjArray.push({
            hubid: this.hubaccess[i].HubID,
            hubname: this.hubaccess[i].HubName
          })
        }
        let getcurrenthubobj = this.hubaccess.find(hubs => hubs.HubID == this.currentHub );
        this.hubid = { hubid: this.currentHub,hubname: getcurrenthubobj.HubName}
        this.hubid1 = { hubid: this.currentHub,hubname: getcurrenthubobj.HubName}
		this.dwshub = { hubid: this.currentHub,hubname: getcurrenthubobj.HubName}
        let payload ={
          username: this.useremail,
          hubid:this.currentHub
        }
        let scandata = await AdminSettingsService.getAdminSettings(payload);
        if(scandata.data.data.hubdata){
          this.isPalletScan = scandata.data.data.hubdata.ispalletscan
          this.scanType = scandata.data.data.hubdata.scantype
		  this.isDwsScanEnable = scandata.data.data.hubdata.isdwsscanenable
        }
        }
        else {
          this.$alertify.error(response.data.message);
        }
        this.isLoading = false;
      } catch(err){
        console.log(err);
        this.isLoading = false;
      }
    },
    async getAdminSettings(){
      try {
        this.isLoading = true;
        let inputPayload = {
          username: this.useremail
        }
        let result = await AdminSettingsService.getAdminSettings(inputPayload);
        this.adminsettingdata = result.data.data.settings;
        let tempHSN = this.getValueByKeyName('EXEMHSN').HSN;
        this.HSNCode = tempHSN.join(",");
        let tempPrintDisabled = this.getValueByKeyName('PRINTDISABLED');
        this.Clientlist.forEach(item => {
          if(tempPrintDisabled.includes(item.clientId)){
            this.selectedClients.push({
              'clientId': item.clientId,
              'clientName': item.clientName,
            })
          }
        });

        //Client Refetence no config clients
        let tempClientReferenceNoConfigClients = this.getValueByKeyName('CLIENTREFERENCENO');
        this.ClientBusinessAccountlist.forEach(item => {
          if(tempClientReferenceNoConfigClients.includes(item.clientId)){
            this.selectedClientsForClientRefNo.push({
              'clientId': item.clientId,
              'clientName': item.clientName,
            })
          }
        });

        //reference no cofig clients
        let tempReferenceNoConfigClients = this.getValueByKeyName('REFERENCENO');
        this.ClientBusinessAccountlist.forEach(item => {
          if(tempReferenceNoConfigClients.includes(item.clientId)){
            this.selectedClientsForRefNo.push({
              'clientId': item.clientId,
              'clientName': item.clientName,
            })
          }
        });

        //weight disabled cofig clients
        let tempWtDisabledConfigClients = this.getValueByKeyName('DISABLEDWEIGHTDIMENSIONS');
        this.ClientBusinessAccountlist.forEach(item => {
          if(tempWtDisabledConfigClients.includes(item.clientId)){
            this.selectedClientsForDisabledWt.push({
              'clientId': item.clientId,
              'clientName': item.clientName,
            })
          }
        });

        let tempStates = this.getValueByKeyName('EBN1LAC').STATES;
        this.SelectedStates=[];
        this.StatesLimit.forEach(item=>{
          if(tempStates.includes(item.statename)){
            this.SelectedStates.push({
              'statename': item.statename.toUpperCase()
            })
          }
        })
        let temproles = this.getValueByKeyName('PRQCONFIG');
        this.roleId=[];
        this.RolesList.forEach(item=>{
          if(temproles.includes(item.rolename)){
            this.roleId.push({
              'rolename': item.rolename
            })
          }
        })
        let tempOriginHubids = this.getValueByKeyName('originhubids');
        let tempOriginArr = [];
        for(var i =0; i<tempOriginHubids.length; i++){
          let hubname = await this.getHubName(tempOriginHubids[i]);
          let hubdetails = {
            hubid: tempOriginHubids[i],
            hubname: hubname
          };
          tempOriginArr.push(hubdetails);
        }
        this.originhubids = tempOriginArr;

        let tempDestHubids = this.getValueByKeyName('destinationhubids');
        let tempDestArr = [];
        for(var i =0; i<tempDestHubids.length; i++){
          let hubname = await this.getHubName(tempDestHubids[i]);
          let hubdetails = {
            hubid: tempDestHubids[i],
            hubname: hubname
          };
          tempDestArr.push(hubdetails);
        }
        this.destinationhubids = tempDestArr;

        this.printstickeroptions = JSON.stringify(this.getValueByKeyName('PRINTTYPELIST'));
        let tempCentral = this.getValueByKeyName('CENTRALDBTABLES');
        tempCentral.forEach(table=>{
          this.selectedTables.push({tablename:table})
        });
        this.redisService = this.getValueByKeyName('REDISSWITCH')[0];
        this.MaxVolWt = this.getValueByKeyName('MAXVOLWT')[0];
        this.MaxVolWtAWB = this.getValueByKeyName('MAXVOLWT')[1];
        this.ftccashlimit = this.getValueByKeyName('FTCAMTLIMIT');
        this.prcutofftime = this.getValueByKeyName('PRCUTOFFTIME').join(":");
        this.prwtthreshold = this.getValueByKeyName('PRWEIGHTTHRESHOLD')
        this.autocutoffweight = this.getValueByKeyName('CUTOFFWEIGHT');
        this.autofetchdatalimit = this.getValueByKeyName('FETCHDATALIMIT');
        this.globaldeliveryflag = this.getValueByKeyName('GLOBALDELIVERYFLAG')[0];
        this.isLoading = false;
      } catch(err){
        console.log(err);
        this.isLoading = false;
      }
    },
    getHubName(hubid) {
      for (var i = 0; i < this.hubaccessObjArray.length; i++) {
        if (this.hubaccessObjArray[i].hubid == hubid) {
          return this.hubaccessObjArray[i].hubname;
        }
      }
    },
    getValueByKeyName(key) {
      for (var i = 0; i < this.adminsettingdata.length; i++) {
        if (this.adminsettingdata[i].key == key) {
          return this.adminsettingdata[i].value;
        }
      }
    },
	async getStatelist(){
      try {
        this.StatesLimit = [];
        let result = await MasterService.getStateList();
        result.data.data.forEach(item=>{
          this.StatesLimit.push({
            'statename': item.statename.toUpperCase()
          })
        })
      }  catch(err){
        console.log(err);
      }
    },
    async getCompanyShortName(){
      try {
        let InputPayload = {};
        var CompanyShortList = [];
        let result = await ClientService.GetClientListByActiveContracts(InputPayload)
        CompanyShortList = result.data.data.rows;
        for (var i = 0; i < CompanyShortList.length; i++) {
          this.Clientlist.push({
            'clientId': CompanyShortList[i].clientid,
            'clientName': CompanyShortList[i].clientshortname,
          });

          this.ClientBusinessAccountlist.push({
            'clientId': CompanyShortList[i].clientbusinessaccountid,
            'clientName': CompanyShortList[i].clientshortname,
          });
		  this.ClientOTPlist.push({
			'clientId':CompanyShortList[i].clientid,
            'clientBusinessAccountId': CompanyShortList[i].clientbusinessaccountid,
            'clientName': CompanyShortList[i].clientshortname,
          });
        }
      } catch(err){
        console.log(err);
      }
    },
    async saveAdminSettings(module,field){
      try {
        this.isLoading = true;
        let inputPayload = {
          username: this.useremail,
        }
        if (module == "booking") {
          let hsncode = this.HSNCode.split(",");
          let states = this.SelectedStates.map(el=>el.statename);
          let tempOriginArr = [];
          let tempDestinationArr = [];
          inputPayload.exemptHSN = {"HSN": hsncode };
          inputPayload.states = {"STATES": states };
          inputPayload.printstickeroptions = this.printstickeroptions;
          for(var i =0; i<this.originhubids.length; i++){
            tempOriginArr.push(this.originhubids[i].hubid);
          }
          for(var i =0; i<this.destinationhubids.length; i++){
            tempDestinationArr.push(this.destinationhubids[i].hubid);
          }
          inputPayload.originhubids = tempOriginArr;
          inputPayload.destinationhubids = tempDestinationArr;
          let tempVolWt = []
          tempVolWt.push(parseInt(this.MaxVolWt))
          tempVolWt.push(parseInt(this.MaxVolWtAWB))
          inputPayload.MaxVolWt = tempVolWt;
        }
        if (module == "flm") {
          if(field == "TripShipmentScan"){
          inputPayload.hubid = this.hubid.hubid;
          inputPayload.scantype = this.scanType;
          }
          inputPayload.ispalletscan = this.isPalletScan;
          inputPayload.hubname = this.hubid.hubname;
		  inputPayload.isdwsscanenable = parseInt(this.isDwsScanEnable);
          let roles = this.roleId.map(el=>el.rolename);
          inputPayload.roles = roles
          if(this.checkErr()){
            this.isLoading = false;
            return false
          }else{
            inputPayload.ftccashlimit = this.ftccashlimit;  // disabling it temp
            inputPayload.ftcsettlementlimit =  parseInt(this.ftcsettlementlimit)
          }
          if (this.prcutofftime && this.prcutofftime.length == 5) {
            inputPayload.prcutofftime = this.prcutofftime.split(":")
          }
          if (this.prwtthreshold) {
            if (Array.isArray(this.prwtthreshold) && this.prwtthreshold.length) {
              inputPayload.prwtthreshold = [this.prwtthreshold[0]]
            } else if (!Array.isArray(this.prwtthreshold)) {
              inputPayload.prwtthreshold = [this.prwtthreshold]
            }
          } else {
            this.isLoading = false;
            return false
          }
          if (this.autocutoffweight) {
            inputPayload.autocutoffweight = [Number(this.autocutoffweight)];
          }
          if (this.autofetchdatalimit) {
            inputPayload.autofetchdatalimit = [Number(this.autofetchdatalimit)];
          }
          if (this.globaldeliveryflag) {
            inputPayload.globaldeliveryflag=[Number(this.globaldeliveryflag)];
          }
        }
        if (module == "clientmanagement") {
          let clients = this.selectedClients.map(item=>item.clientId);
          inputPayload.printdisabledclients = clients;

          let clientsclientrefno = this.selectedClientsForClientRefNo.map(item=>item.clientId);
          inputPayload.clientreferencenoclients = clientsclientrefno;

          let clientsrefno = this.selectedClientsForRefNo.map(item=>item.clientId);
          inputPayload.referencenoclients = clientsrefno;

          let clientsdisabledwtdim = this.selectedClientsForDisabledWt.map(item=>item.clientId);
          inputPayload.disabledweightdimensionsclients = clientsdisabledwtdim;
        }
        if (module == "centraldb") {
          inputPayload.centraldbtables = this.selectedTables.map(item=>item.tablename.toLowerCase());
        }
        if (module == "redis") {
          let tempRedisArr = [];
          tempRedisArr.push(parseInt(this.redisService))
          inputPayload.redisService = tempRedisArr
        }
        let result = await AdminSettingsService.saveAdminSettings(inputPayload);
        this.isLoading = false;
        if (result.data.code == 200) {
		  await this.getAdminSettings();
          this.$alert(result.data.message, "", "success");
        }else{
          this.$alert(result.data.message, "", "error");
        }
      } catch(err){
        console.log(err);
        this.isLoading = false;
      }
    },
	prcutOffcheck(event) {
    let keyList=['Backspace', ':','1', '2', '3', '4', '5', '6', '7', '8', '9', '0']
    if (keyList.includes(event.key)) {

      if (this.prCutoofSelected > 1) {
        this.prCutoofSelected = this.prCutoofSelected - 1;
        return;
      }
      if (this.prCutoofBackspace > 1) {
        this.prCutoofBackspace = this.prCutoofBackspace - 1;
        return;
      }
      if (event.key != 'Backspace') {
        this.prCutoofBackspace = 0
        let regNum = /^[0-9]+$/;
        if (this.prcutofftime && !this.prcutofftime[this.prcutofftime.length - 1].match(regNum)) {
          this.prcutofftime = this.prcutofftime.slice(0, -1);
        }
        const value = this.prcutofftime.replace(/[^0-9]/g, "");
        if (value.length > 2) {
          this.prcutofftime = value.slice(0, 2) + ":" + value.slice(2);
        } else if (value.length == 2) {
          this.prcutofftime = value.slice(0, 2) + ":";
        }

        let prCutoffsplit = this.prcutofftime.split(":");
        if (prCutoffsplit[0] && prCutoffsplit[0].length == 2 && (Number(prCutoffsplit[0]) < 0 || Number(prCutoffsplit[0]) > 23)) {
          prCutoffsplit[0] = "00";
          this.prcutofftime = prCutoffsplit.join(":");
        }
        if (prCutoffsplit[1] && prCutoffsplit[1].length == 2 && (Number(prCutoffsplit[1]) < 0 || Number(prCutoffsplit[1]) > 59)) {
          prCutoffsplit[1] = "00";
          this.prcutofftime = prCutoffsplit.join(":");
        }
      } else {
        this.prCutoofBackspace = this.prCutoofBackspace + 1
      }
    }else {
      if (!this.prcutofftime[this.prcutofftime.length-1].match(/\d|\:/) ) {
        this.prcutofftime = this.prcutofftime.slice(0, -1);
      }
    }
	},
  selectedPR(event){
    this.prCutoofSelected =  event.target.selectionEnd - event.target.selectionStart;
    if (this.prCutoofSelected>2) {
      this.prCutoofSelected = 0
    }
  },
    checkErr(){
      let err = false
      if(this.ftccashlimit == "" ||this.ftccashlimit==null){
        err = true
        this.FTCAMterr = "please enter FTC cash collect limit"
      }
      if(this.ftcsettlementlimit == "" ||this.ftcsettlementlimit==null){
        err = true
        this.ftcunsettlederr = "Please Enter FTC Unsettled Cash Limit"
      }
      return err
    },
    async getRoleList(){
      try {
        this.isLoading = true;
        this.RolesList = [];
        let result = await MasterService.getRolesList();
        this.isLoading = false;
        if (result.data.code == 200) {
          result.data.data.rows.forEach(item=>{
              this.RolesList.push({
                'rolename':item.rolename
              });
          })
        }else {
          this.rolesList = [];
          this.$alert("Internal Server Error",'Admin Setting', "error");
        }
      }  catch(err){
        console.log(err);
      }
    },
	  async saveClientSettings(module){
		try {
		  this.isLoading = true;
		  if(this.selectedClients.clientId){
			let inputPayload = {
				username: this.useremail,
			  }
			this.clientdata = {
				mpsprintdisabled: this.mpsPrintDisabledClients == true ? 1 :0,
				referenceno: this.ReferenceNolist == true ? 1 : 0,
				clientreferenceno: this.ClientReferenceNolist ? 1 : 0,
				clientdisabledwt : this.ClientsForDisabledWt ? 1 : 0,
        clientdisabledws : this.ClientsForDisableDWS ?1 :0,
				otpbaseddelivery: this.OTPBasedDelivery ? 1 : 0,
        consigneecodeonmpssticker : this.ConsigneeCodeOnMps ? 1 :0,
				realiancesecondaryclient : this.RelianceSecondaryClient ? 1 : 0,
				poprequired: this.ProofOfPickup ? 1 : 0,
        enableverificationflag: this.enableverification ? 1 : 0
			}
			if(this.awblrcopydata && Object.keys(this.awblrcopydata).length>0){
				this.clientdata.awbcopy = this.awblrcopydata
			}
			if(this.mpsstickerdata && Object.keys(this.mpsstickerdata).length>0){
				this.clientdata.mpscopy = this.mpsstickerdata
			}
      if(this.pincode && Object.keys(this.pincode).length>0){
				this.clientdata.pincode = this.pincode
			}
			if(this.globaldropoffpincode && Object.keys(this.globaldropoffpincode).length>0){
				this.clientdata.globaldropoffpincode = this.globaldropoffpincode
			}
      if(this.globaldeliverypincode && Object.keys(this.globaldeliverypincode).length>0){
				this.clientdata.globaldeliverypincode = this.globaldeliverypincode
      }
      if(this.blockclientcode && Object.keys(this.blockclientcode).length>0){
				this.clientdata.blockclientcode = this.blockclientcode
			}
			let clientid = this.selectedClients.clientId
			let clientBusinessAccountId = this.selectedClients.clientBusinessAccountId
			let clientName = this.selectedClients.clientName

			inputPayload.clientData = this.clientdata
			inputPayload.clientId = clientid
			inputPayload.clientBusinessAccountId = clientBusinessAccountId
			let result = await AdminSettingsService.saveClientSettings(inputPayload);
			this.isLoading = false;
			if (result.data.code == 200) {
				this.$alert(result.data.message, "", "success");
			}else{
				this.$alert(result.data.message, "", "error");
			}	
		  }else{
			this.isLoading = false;
			this.$alertify.error("Please select client name")
		  }
		} catch (error) {
		   console.log(error);
           this.isLoading = false;
		} 
	  },
	 async onSelectClient (event) {
		if (event.clientId) {
		  this.resetAWBCopy()
		  this.resetMPSCopy()
      this.resetGlobalPickup('all')
      this.resetBlockClientCodeData()
	  this.resetGlobalDropoff()
		  await this.fecthClientDetails(event.clientId,event.clientBusinessAccountId);
		}else{
		  this.$alert(result.data.message, "", "error");
		}
	  },
	  async fecthClientDetails(clientid,clientbusinessaccid){
		try {
			this.isLoading = true;
			let inputPayload = {}
			inputPayload.clientId = clientid
			inputPayload.clientBusinessAccountId = clientbusinessaccid
			let result = await AdminSettingsService.getClientSettings(inputPayload)
			this.isLoading = false;
			if (result.data.code == 200) {
				let clientSettingData  = result.data.data[0].configparam
				this.mpsPrintDisabledClients = result.data.data[0].configparam.mpsprintdisabled == 1 ? true : false
				this.ReferenceNolist = result.data.data[0].configparam.referenceno == 1 ? true : false
				this.ClientReferenceNolist = result.data.data[0].configparam.clientreferenceno == 1 ? true : false
				this.ClientsForDisabledWt = result.data.data[0].configparam.clientdisabledwt == 1 ? true : false
        this.ClientsForDisableDWS = result.data.data[0].configparam.clientdisabledws == 1 ? true : false
				this.OTPBasedDelivery = result.data.data[0].configparam.otpbaseddelivery == 1 ? true : false
				this.awblrcopy = false;
				if(clientSettingData.awbcopy){
					this.awblrcopy = result.data.data[0].configparam.awbcopy.ischecked!=0 ? true : false 
				}
				if(this.awblrcopy){
				  this.awblrcopydata = clientSettingData.awbcopy
				  this.clientdata.awbcopy = clientSettingData.awbcopy
				  this.bookinglabel1 = clientSettingData.awbcopy.field1 != null ? clientSettingData.awbcopy.field1.label : "",
				  this.bookingfield1 = clientSettingData.awbcopy.field1 != null ? clientSettingData.awbcopy.field1.columnname : ""
				  if(clientSettingData.awbcopy.field1 != null){
					this.updateLRDropdown('field1',this.bookingfield1)
				  }
				  this.bookinglabel2 = clientSettingData.awbcopy.field2 != null ? clientSettingData.awbcopy.field2.label : "",
				  this.bookingfield2 = clientSettingData.awbcopy.field2 != null ? clientSettingData.awbcopy.field2.columnname : ""
				  if(clientSettingData.awbcopy.field2 != null){
					this.updateLRDropdown('field2',this.bookingfield2)
				  }
				  this.bookinglabel3 = clientSettingData.awbcopy.field3 != null ? clientSettingData.awbcopy.field3.label : "",
				  this.bookingfield3 = clientSettingData.awbcopy.field3 != null ? clientSettingData.awbcopy.field3.columnname : ""
				  if(clientSettingData.awbcopy.field3 != null){
					this.updateLRDropdown('field3',this.bookingfield3)
				  }
				}
				this.mpssticker = false;
				if(clientSettingData.mpscopy){
					this.mpssticker = result.data.data[0].configparam.mpscopy.ischecked!=0 ? true : false 
				}
				if(this.mpssticker){
				  this.mpsstickerdata = clientSettingData.mpscopy
				  this.clientdata.mpscopy = clientSettingData.mpscopy	
				  this.bookingmpslabel1 = clientSettingData.mpscopy.field1 != null ? clientSettingData.mpscopy.field1.label : "",
				  this.bookingmpsfield1 = clientSettingData.mpscopy.field1 != null ? clientSettingData.mpscopy.field1.columnname : ""
				  if(clientSettingData.mpscopy.field1 != null){
					this.updateMpsStickerDropdown('field1',this.bookingmpsfield1)
				  }
				  this.bookingmpslabel2 = clientSettingData.mpscopy.field2 != null ? clientSettingData.mpscopy.field2.label : "",
				  this.bookingmpsfield2 = clientSettingData.mpscopy.field2 != null ? clientSettingData.mpscopy.field2.columnname : ""
				  if(clientSettingData.mpscopy.field2 != null){
					this.updateMpsStickerDropdown('field2',this.bookingmpsfield2)
				  }
				}
				this.ConsigneeCodeOnMps = result.data.data[0].configparam.consigneecodeonmpssticker == 1 ? true : false
				this.RelianceSecondaryClient = result.data.data[0].configparam.realiancesecondaryclient == 1 ? true : false
				this.ProofOfPickup = result.data.data[0].configparam.poprequired == 1 ? true : false
        this.enableverification = result.data.data[0].configparam.enableverificationflag == 1 ? true : false
        if(clientSettingData.pincode)
        {
          this.globalpickup= (result.data.data[0].configparam.pincode).length>0 ? true : false 
        }
        if(this.globalpickup){
				this.pincode= clientSettingData.pincode
				}
        if(clientSettingData.globaldeliverypincode) {
          this.globaldelivery=false;
          if ((result.data.data[0].configparam.globaldeliverypincode).length>0) {
            this.globaldelivery=true
            this.globaldeliverypincode= clientSettingData.globaldeliverypincode
          }
        }
        if(clientSettingData.blockclientcode)
        {
          this.blockpickup = clientSettingData.blockclientcode.blockpickup == 1 ? true : false;
          this.blockdelivery = clientSettingData.blockclientcode.blockdelivery == 1 ? true : false;
          if (this.blockpickup || this.blockdelivery)  {
            this.blockclientreason = clientSettingData.blockclientcode.blockclientreason; 
          }else{
            this.blockclientreason = ''
          }
        }
		if(clientSettingData.globaldropoffpincode) {
			this.globaldropoff=false;
			if ((result.data.data[0].configparam.globaldropoffpincode).length>0) {
			  this.globaldropoff=true
			  this.globaldropoffpincode= clientSettingData.globaldropoffpincode
			}
		  }

			//this.$alert(result.data.message, "", "success");
			}else{
				this.mpsPrintDisabledClients = result.data.data[0].configparam.mpsprintdisabled == 1 ? true : false
				this.ReferenceNolist = result.data.data[0].configparam.referenceno == 1 ? true : false
				this.ClientReferenceNolist =  result.data.data[0].configparam.clientreferenceno == 1 ? true : false
				this.ClientsForDisabledWt = result.data.data[0].configparam.clientdisabledwt == 1 ? true : false
        this.ClientsForDisableDWS = result.data.data[0].configparam.clientdisabledws == 1 ? true : false
				this.OTPBasedDelivery = result.data.data[0].configparam.otpbaseddelivery == 1 ? true : false
        		this.ConsigneeCodeOnMps = result.data.data[0].configparam.consigneecodeonmpssticker == 1 ? true : false
				this.awblrcopy = result.data.data[0].configparam.awbcopy!=0 ? true : false
				this.mpssticker = result.data.data[0].configparam.mpscopy!=0 ? true : false
        		this.RelianceSecondaryClient = result.data.data[0].configparam.realiancesecondaryclient == 1 ? true : false
				this.ProofOfPickup = result.data.data[0].configparam.poprequired == 1 ? true : false
        this.enableverification = result.data.data[0].configparam.enableverificationflag == 1 ? true : false
			}
		} catch (error) {
			console.log(error);
			this.isLoading = false;
		}
	  },
	  closeClientDetails(){
		this.ShowClientDetails = false
		this.ShowAwbCopy = false
		this.ShowMpsCopy = false
    this.ShowClientDetailsforglobalpickup=false
    this.ShowGlobalPickup=false
	    this.ShowGlobalDropoff=false
    this.ShowGlobalDelivery=false
	  },
	  
	  async getAllClient(action){
		try {
			this.isLoading = true;
			this.clientlist=[]
			let inputPayload={}
			inputPayload.key = action
			let result = await AdminSettingsService.getAllKeyClient(inputPayload)
			this.isLoading = false;
			if(result.data.code == 200){
				result.data.data.map(obj=>{
					this.clientlist.push(obj.clientshortname)
				})
			}
			this.clinetnamelist = this.clientlist.toString().replaceAll(',' , ', ');
			this.ShowClientDetails = true
		} catch (error) {
			console.log(error);
			this.isLoading = false;
		}
	  },
	  async handler(action,event){
		try {
		  this.isLoading = true;
		  if(this.selectedClients.clientId){
			  this.isLoading = false;
			  if(action == 'awbcopy'){
				  this.printcopy = 'AWB Copy Customisation'
				  this.ShowAwbCopy = true      
			  }else if(action == 'enableclient'){
          this.printcopy = 'Block Client Pickup/Delivery'
          this.blockclient = true
          if (!this.blockpickup && !this.blockdelivery) {
            this.blockclientreason = ''
          }
        }else{
				  this.printcopy = 'MPS Sticker Customisation'
				  this.ShowMpsCopy = true
			  }
		  }else{
			  this.isLoading = false;
			  this.$alertify.error("Please select client name")
		  }
		} catch (error) {
		  this.isLoading = false;
		}
	  },
	  saveAwbCopyData(){
		  try {
			  this.isLoading = true;
			  if(this.selectedClients.clientId){
				  if(this.bookinglabel1!='' && this.bookingfield1==''){
					  this.$alertify.error("Please enter Field1 Value");
					  this.isLoading = false;
					  return false;
				  }else if(this.bookinglabel1=='' && this.bookingfield1!=''){
					this.$alertify.error("Please enter Field1 Label");
					this.isLoading = false;
					return false;
				  }
				  if(this.bookinglabel2!='' && this.bookingfield2==''){
					  this.$alertify.error("Please enter Field2 Value");
					  this.isLoading = false;
					  return false;
				  }else if(this.bookinglabel2=='' && this.bookingfield2!=''){
					this.$alertify.error("Please enter Field2 Label");
					this.isLoading = false;
					return false;
				  }
				  if(this.bookinglabel3!='' && this.bookingfield3==''){
					  this.$alertify.error("Please enter Field3 Value");
					  this.isLoading = false;
					  return false;
				  }else if(this.bookinglabel3=='' && this.bookingfield3!=''){
					this.$alertify.error("Please enter Field3 Label");
					this.isLoading = false;
					return false;
				  }
				  if(this.bookinglabel1 == '' && this.bookingfield1==''){
					  this.selectedAwbCopy[0] = null
				  }else{
					  this.selectedAwbCopy[0] = {label:this.bookinglabel1,columnname:this.bookingfield1}
				  }
				  if(this.bookinglabel2 == '' && this.bookingfield2==''){
					  this.selectedAwbCopy[1] = null
				  }else{
					  this.selectedAwbCopy[1] = {label:this.bookinglabel2,columnname:this.bookingfield2}
				  }
				  if(this.bookinglabel3 == '' && this.bookingfield3==''){
					  this.selectedAwbCopy[2] = null
				  }else{
					  this.selectedAwbCopy[2] = {label:this.bookinglabel3,columnname:this.bookingfield3}
				  }
				  this.awblrcopydata={
					  ischecked:1,
					  field1: this.selectedAwbCopy[0],// null
					  field2: this.selectedAwbCopy[1],// null
					  field3: this.selectedAwbCopy[2] // null
				  }
				  if(this.selectedAwbCopy[0] == null && this.selectedAwbCopy[1]== null && this.selectedAwbCopy[2] == null){
					  this.awblrcopydata.ischecked = 0
				  }
				  this.isLoading = false;
				  this.saveClientSettings();
				  this.$alertify.success("Data added Successfully");
				  this.ShowAwbCopy = false
			  }else{
				  this.isLoading = false;
				  this.$alertify.error("Please select client name")
			  }	
		  } catch (error) {
			  this.isLoading = false;
			  console.log(error);
		  }
	  },
	  setawbcopy(event,field){
		  try {
			  if(field == 'field1'){
				  this.updateLRDropdown(field,this.bookingfield1)
				  this.selectedAwbCopy[0] = {label:this.bookinglabel1,columnname:this.bookingfield1}
			  } 
			  if(field == 'field2'){
				  this.updateLRDropdown(field,this.bookingfield2)
				  this.selectedAwbCopy[1] = {label:this.bookinglabel2,columnname:this.bookingfield2}
			  }
			  if(field == 'field3'){
				  this.updateLRDropdown(field,this.bookingfield3)
				  this.selectedAwbCopy[2] = {label:this.bookinglabel3,columnname:this.bookingfield3}
			  }	
		  } catch (error) {
			  this.isLoading = false;
			  console.log(error);
		  }
	  },
	  updateLRDropdown(field,selectedvalue){
		  try {
			  if(field == 'field1'){
				  this.bookingfieldlist2.forEach(item=>{
					  if(item.value == selectedvalue){
						item.disable = 1
					  }else if(item.value == this.bookingfield1){
						item.disable = 1
					  }else if(item.value == this.bookingfield3){
						item.disable = 1
					  }else{
						item.disable = 0;
					  }
				  })
				  this.bookingfieldlist3.forEach(item=>{
					  if(item.value == selectedvalue){
						  item.disable = 1
					  }else if(item.value == this.bookingfield1){
							item.disable = 1
					  }else if(item.value == this.bookingfield2){
						item.disable = 1;
					  }else{
						item.disable = 0;
					  }
				  })
			  }
			  if(field == 'field2'){
				  this.bookingfieldlist1.forEach(item=>{
					  if(item.value == selectedvalue){
						  item.disable = 1
					  }else if(item.value == this.bookingfield2){
						item.disable = 1
					  }else if(item.value == this.bookingfield3){
						item.disable = 1
					  }else{
						item.disable = 0;
					  }
				  })
				  this.bookingfieldlist3.forEach(item=>{
					  if(item.value == selectedvalue){
						  item.disable = 1
					  }else if(item.value == this.bookingfield1){
						item.disable = 1
					  }else if(item.value == this.bookingfield2){
						item.disable = 1
					  }else{
						item.disable = 0;
					  }
				  })
			  }
  
			  if(field == 'field3'){
				  this.bookingfieldlist1.forEach(item=>{
					  if(item.value == selectedvalue){
						  item.disable = 1
					  }else if(item.value == this.bookingfield2){
						item.disable = 1
					  }else if(item.value == this.bookingfield3){
						item.disable = 1
					  }else{
						item.disable = 0;
					  }
				  })
				  this.bookingfieldlist2.forEach(item=>{
					  if(item.value == selectedvalue){
						  item.disable = 1
					  }else if(item.value == this.bookingfield1){
						item.disable = 1
					  }else if(item.value == this.bookingfield3){
						item.disable = 1
					  }else{
						item.disable = 0;
					  }
				  })
			  }
		  } catch (error) {
			  console.log(error)
		  }
	  },
	  updateMpsStickerDropdown(field,selectedvalue){
		  try {
			  if(field == 'field1'){
				  this.mpsfieldlist2.forEach(item=>{
					  if(item.value == selectedvalue){
						  item.disable = 1
					  }else{
						  item.disable = 0
					  }
				  })
			  }
			  if(field == 'field2'){
				  this.mpsfieldlist1.forEach(item=>{
					  if(item.value == selectedvalue){
						  item.disable = 1
					  }else{
						  item.disable = 0
					  }
				  })
			  }
		  } catch (error) {
			  console.log(error)
		  }
	  },
	  saveMpsStickerData(){
		  try {
			  this.isLoading = true;
			  if(this.selectedClients.clientId){
				  if(this.bookingmpslabel1!='' && this.bookingmpsfield1==''){
					  this.$alertify.error("Please enter Field1 Value");
					  this.isLoading = false;
					  return false;
				  }else if(this.bookingmpslabel1=='' && this.bookingmpsfield1!=''){
					this.$alertify.error("Please enter Field1 Label");
					this.isLoading = false;
					return false;
				  }
				  if(this.bookingmpslabel2!='' && this.bookingmpsfield2==''){
					  this.$alertify.error("Please enter Field2 Value");
					  this.isLoading = false;
					  return false;
				  }else if(this.bookingmpslabel2=='' && this.bookingmpsfield2!=''){
					this.$alertify.error("Please enter Field2 Label");
					this.isLoading = false;
					return false;
				  }
				  if(this.bookingmpslabel1 == '' && this.bookingmpsfield1==''){
					  this.selectedMpsCopy[0] = null
				  }else{
					  this.selectedMpsCopy[0] = {label:this.bookingmpslabel1,columnname:this.bookingmpsfield1}
				  }
				  if(this.bookingmpslabel2 == '' && this.bookingmpsfield2==''){
					  this.selectedMpsCopy[1] = null
				  }else{
					  this.selectedMpsCopy[1] = {label:this.bookingmpslabel2,columnname:this.bookingmpsfield2}
				  }
				  this.mpsstickerdata={
					  ischecked:1,
					  field1: this.selectedMpsCopy[0],// null
					  field2: this.selectedMpsCopy[1],// null
				  }
				  if(this.selectedMpsCopy[0] == null && this.selectedMpsCopy[1]== null){
					  this.mpsstickerdata.ischecked = 0
				  }
				  this.isLoading = false;
				  this.saveClientSettings();
				  this.$alertify.success("Data added Successfully");
				  this.ShowMpsCopy = false
			  }else{
				  this.isLoading = false;
				  this.$alertify.error("Please select client name")
			  }	
		  } catch (error) {
			  this.isLoading = false;
			  console.log(error)
		  }
  
	  },
	  setmpscopy(event,field){
		  try {
			  if(field == 'field1'){
				  this.updateMpsStickerDropdown(field,this.bookingmpsfield1)
				  this.selectedMpsCopy[0] = {label:this.bookingmpslabel1,columnname:this.bookingmpsfield1}
			  } 
			  if(field == 'field2'){
				  this.updateMpsStickerDropdown(field,this.bookingmpsfield2)
				  this.selectedMpsCopy[1] = {label:this.bookingmpslabel2,columnname:this.bookingmpsfield2}
			  }
		  } catch (error) {
			  console.log(error);
		  }
	  },
	  resetAWBCopy(){
		  try {
			  this.bookinglabel1 = ""
			  this.bookingfield1 = ""
			  this.bookinglabel2 = ""
			  this.bookingfield2 = ""
			  this.bookinglabel3 = ""
			  this.bookingfield3 = ""
			  this.bookingfieldlist1.forEach(item=>{
				item.disable = 0;
			  })
			  this.bookingfieldlist2.forEach(item=>{
				item.disable = 0;
			  })
			  this.bookingfieldlist3.forEach(item=>{
				item.disable = 0;
			  })
			  this.selectedAwbCopy[0] = null
			  this.selectedAwbCopy[1] = null
			  this.selectedAwbCopy[2] = null
		  } catch (error) {
			  console.log(error)
		  }
	  },
	  resetMPSCopy(){
		  try {
			  this.bookingmpslabel1 = ""
			  this.bookingmpsfield1 = ""
			  this.bookingmpslabel2 = ""
			  this.bookingmpsfield2 = ""
			  this.mpsfieldlist1.forEach(item=>{
				item.disable = 0;
			  })
			  this.mpsfieldlist2.forEach(item=>{
				item.disable = 0;
			  })
			  this.selectedMpsCopy[0] = null
			  this.selectedMpsCopy[1] = null
		  } catch (error) {
			  console.log(error)
		  }
	  },
    saveGlobalPickupData(){
		  try {
			  this.isLoading = true;
			  if(this.selectedClients.clientId){
          if(typeof(this.pincode) === 'string')
          {
            this.globalpickuppincodedataArray=this.pincode.split(",")
            if( this.globalpickuppincodedataArray.length>0)
            {
              var pincodeArray = this.globalpickuppincodedataArray.map(str => parseInt(str, 10));
              this.pincode=this.isArrayEqualNaN(pincodeArray)?[]:pincodeArray
            }
          }
				  this.isLoading = false;
				  this.saveClientSettings();
				  this.ShowAwbCopy = false
			  }else{
				  this.isLoading = false;
				  this.$alertify.error("Please select client name")
			  }	
		  } catch (error) {
			  this.isLoading = false;
			  console.log(error);
		  }
	  },
    saveGlobalDeliveryData(){
		  try {
			  this.isLoading = true;
			  if(this.selectedClients.clientId){
          if(typeof(this.globaldeliverypincode) === 'string')
          {
            this.globalpickuppincodedataArray=this.globaldeliverypincode.split(",")
            if( this.globalpickuppincodedataArray.length>0)
            {
              var pincodeArray = this.globalpickuppincodedataArray.map(str => parseInt(str, 10));
              this.globaldeliverypincode=this.isArrayEqualNaN(pincodeArray)?[]:pincodeArray
            }
          }
				  this.isLoading = false;
				  this.saveClientSettings();
				  this.ShowAwbCopy = false
			  }else{
				  this.isLoading = false;
				  this.$alertify.error("Please select client name")
			  }	
		  } catch (error) {
			  this.isLoading = false;
			  console.log(error);
		  }
	  },
     isArrayEqualNaN(arr) {
      if (!Array.isArray(arr)) {
        return false; // Not an array
      }
      if (arr.length !== 1) {
        return false; // Array length is not 1
      }
      return isNaN(arr[0]);
    },
    resetGlobalPickup(action)
    {
      if(action=='globalpickup') {
     this.pincode=[]
      }if(action=='globaldeliver') {
      this.globaldeliverypincode=[]
      } else {
        this.globaldeliverypincode=[]
        this.pincode=[]
      }
    },
    async GlobalPickupPincode(action,event){
      try {
        this.isLoading = true;
        if(this.selectedClients.clientId && action == 'pincode'){
            this.isLoading = false;
            this.ShowGlobalPickup = true
        }else if(this.selectedClients.clientId  && action=='globaldropoffpincode' ){
			this.isLoading = false;
			this.ShowGlobalDropoff = true
		}else{
          this.isLoading = false;
          this.$alertify.error("Please select client name")
        }
      } catch (error) {
        this.isLoading = false;
      }
      },
    async getAllClientforGlobalPickup(action){
      try {
        this.isLoading = true;
        this.clientlist=[]
        this.GlobalPickupViewData={}
        let inputPayload={}
        inputPayload.key = action
        let result = await AdminSettingsService.getAllKeyClient(inputPayload)
        this.isLoading = false;
        if(result.data.code == 200){
          this.GlobalPickupClientPincodeData=result.data.data
        }
        else{
          this.GlobalPickupClientPincodeData={clientname:null,pincode:[]}
        }
        this.clinetnamelist = this.clientlist.toString().replaceAll(',' , ', ');
        this.ShowClientDetailsforglobalpickup = true
      } catch (error) {
        this.isLoading = false;
      }
      },
      saveBlockClientCodeData(){
        try {
          this.isLoading = true;
          if(this.selectedClients.clientId){
            if(this.blockclientreason==''){
              this.$alertify.error("Please enter resason");
              this.isLoading = false;
              return false;
            }
            if (this.blockpickup || this.blockdelivery) {
              this.blockclientcode = {
                blockpickup : this.blockpickup ? 1 : 0,
                blockdelivery : this.blockdelivery ? 1 : 0,
                blockclientreason : this.blockclientreason,
                ischecked : 1
              }
            }else{
              this.blockclientcode = {}
            }
            this.isLoading = false;
            this.saveClientSettings();
            this.$alertify.success("Data added Successfully");
            this.blockclient = false
          }else{
            this.isLoading = false;
            this.$alertify.error("Please select client name")
          }	
        } catch (error) {
          this.isLoading = false;
          console.log(error);
        }
      },
      resetBlockClientCodeData(){
        try {
          this.blockpickup = 0 ;
          this.blockdelivery = 0 ;
          this.blockclientreason="" ;
          this.blockclientcode = {}
        } catch (error) {
          console.log(error)
        }
      },
	  saveGlobalDropoffData() {
	  	try {
	  		this.isLoading = true;
	  		if (this.selectedClients.clientId) {
	  			if (typeof (this.globaldropoffpincode) === 'string') {
	  				this.globaldropoffpincodedataArray = this.globaldropoffpincode.split(",")
	  				if (this.globaldropoffpincodedataArray.length > 0) {
						if(this.globaldropoffpincodedataArray[0]=='ALL'){
							this.globaldropoffpincode = ['ALL']
						}else{
							var pincodeArray = this.globaldropoffpincodedataArray.map(str => parseInt(str, 10));
							this.globaldropoffpincode = this.isArrayEqualNaN(pincodeArray) ? [] : pincodeArray
						}
	  				}
	  			}
	  			this.isLoading = false;
	  			this.saveClientSettings();
				this.ShowGlobalDropoff = false
	  		} else {
	  			this.isLoading = false;
	  			this.$alertify.error("Please select client name")
	  		}
	  	} catch (error) {
	  		this.isLoading = false;
	  		console.log(error);
	  	}
	  },
    resetGlobalDropoff()
    {
     this.globaldropoffpincode=[]
    },

  }
}
Validator.extend('verify_hsncode', {
  getMessage: field => "Invalid HSN Code entered.",
  validate: value => {
    var HSNCode = $("#HsnCode").val();
    let HCode=HSNCode.split(/[,]+/);
    let flag=0;
    for (let i = 0; i < HCode.length; i++) {
      if(isNaN(HCode[i]) ){
        flag=1;
      }
    }
    if(flag==1){
      return false;
    }else{
      return true;
    }
  }
});
Validator.extend('verify_states', {
  getMessage: field => "Invalid name(s) of state(s) entered.",
  validate: value => {
    var stateslist = $("#StatesLimit").val();
    let statenames=stateslist.split(/[,]+/);
    let flag=0;
    if(flag==1){
      return false;
    }else{
      return true;
    }
  }
});
Validator.extend('verify_prcutoff', {
  getMessage: field => "Invalid PR Cut-Off time entered.",
  validate: value => {
    var PRCutofftime = $("#prcutofftime").val();
    if (PRCutofftime.length!=5) {
      return false
    }
    let PRCutoff=PRCutofftime.split(":");
    if (PRCutoff[0].length== 2 && PRCutoff[1].length== 2) {
      return true;
    } else{
      return false;
    }
  }
});
Validator.extend('verify_pincode', {
  getMessage: field => "The Pincode field format is invalid",
  validate: value => {
  if (value.match(/^\d{6}(,\d{6})*$/)) {
    this.disablesave=false
  return true
  }else{
    this.disablesave=true
  return false;
  }
  }
  });
  Validator.extend('verify_globaldropoffpincode', {
	getMessage: field => "The Pincode field format is invalid",
	validate: value => {
	if (value.match(/^\d{6}(,\d{6})*$/) || value=='ALL') {
	  this.disablesave=false
	return true
	}else{
	  this.disablesave=true
	return false;
	}
	}
	});
  
Validator.extend('verify_deliverypincode', {
  getMessage: field => "The Pincode field format is invalid",
  validate: value => {
    if (value.match(/^\d{6}(,\d{6})*$/)) {
      this.disablesave = false
      return true
    } else {
      this.disablesave = true
      return false;
    }
  }
  });
  



// WEBPACK FOOTER //
// ./src/modules/adminsettings/views/configuration/configuration.component.js